export default function getResource(label) {
    const resources = {
        change: 'Change'
    };

    return resources[label];
}
